import { UnsubscribedProducer } from 'interface/notifications';
import { del, get, post, put } from 'services/api';
import { API_V4_BASE_URL, NOTIFICATION_CENTER_URL } from 'settings';
import { toastError, toastSuccess } from 'utils/reduxToast';

interface Data {
  reason: string;
  trackId: string;
}

export const getNotificationConfig = () => {
  return get({ baseURL: NOTIFICATION_CENTER_URL, url: `/config` })
    .then((response) => response.data)
    .catch(() => toastError('Ocorreu um erro ao pegar suas configurações!'));
};

export const saveNotificationConfig = (data: any) => {
  return put({ baseURL: NOTIFICATION_CENTER_URL, url: `/config`, data })
    .then((response) => {
      toastSuccess('Configurações atualizadas com sucesso!');
      return response.data;
    })
    .catch(() => toastError('Ocorreu um erro ao salvar suas configurações!'));
};

export const getUnsubscribedProducers = (): Promise<UnsubscribedProducer[]> => {
  return get({ baseURL: API_V4_BASE_URL, url: `/unsubscribe/producers` }).then((response) => response.data);
};

export const subscribeToProducer = (producerId: number) => {
  return del({ baseURL: NOTIFICATION_CENTER_URL, url: `/unsubscribe/producers/${producerId}` })
    .then((response) => response.data)
    .catch(() => toastError('Ocorreu um erro ao subscrever ao produtor novamente!'));
};

export const saveUnsubscribeFeedback = (data: Data) => {
  return post({ baseURL: NOTIFICATION_CENTER_URL, url: '/unsubscribe/feedback', data }).catch(() =>
    toastError('Não foi possível salvar seu feedback no momento')
  );
};
